import React, { useId } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface HorizontalStatusGroupProps {
  colour: string;
  label: string;
  colourName: string;
}

function HorizontalStatusGroup(props: HorizontalStatusGroupProps) {
  return (
    <Box
      component="li"
      display="flex"
      alignItems="center"
      gap={2}
      flexWrap="nowrap"
      minWidth="0"
      flexShrink="0"
      marginLeft={props.label === 'Unsubmitted' ? 'auto' : 0}
    >
      <GraphStatusSVGRectangle {...props} />
      <Typography variant="caption" component="p" aria-hidden="true">
        {props.label}
      </Typography>
    </Box>
  );
}

export function GraphStatusSVGRectangle({ colour, label, colourName }: HorizontalStatusGroupProps) {
  const titleId = useId();
  const descId = useId();
  const description = `Contributions with status ${label.toLowerCase()} are represented in ${colourName} colour`;

  return (
    <svg
      role="img"
      aria-labelledby={`${titleId} ${descId}`}
      version="1.1"
      width="32"
      height="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title id={titleId}>{label}</title>
      <desc id={descId}>{description}</desc>
      <rect width="100%" height="100%" rx="3" ry="3" fill={colour} />
    </svg>
  );
}

export default React.memo(HorizontalStatusGroup);
